/** Angular */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
/** Sixense */
/** Services */
import { BydRhsAbstractService } from '../../../shared/services/byd-rhs-abstract.service';
/** Models */
import { BuildingLevelFull } from '../../building-level.class';
import { PlanView } from '../../plan-view.class';

@Injectable({
  providedIn: 'root',
})
export class BydPlansService extends BydRhsAbstractService {
  /**
   * Implement inherited abstract member 'path' from BydRhsAbstractService.
   */
  path: string;

  /**
   * Get the plan view.
   *
   * @param projectId the project id
   * @returns Observable<PlanView[]>
   * @memberof BydPlansService
   */
  public getPlanViews(projectId: number): Observable<PlanView[]> {
    this.path = `/projects/${projectId}/views`;
    return this.get();
  }

  /**
   * Add plan view.
   *
   * @param projectId the project name
   * @param nameViews the name views
   * @param fileViews the file views
   * @returns Observable
   */
  // TODO:  Set up the correct type
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public addPlanView(projectId: number, nameViews: string, fileViews: File): Observable<any> {
    this.path = `/projects/${projectId}/views`;
    const headers = this.bydConfigService.headers.delete('Content-Type');
    const body: FormData = new FormData();
    body.append('file', fileViews, nameViews);
    body.append('name', nameViews);

    return this.post({ body, headers });
  }

  /**
   * Rename plan view.
   *
   * @param projectId the project name
   * @param planId the plan id name
   * @param planName the plan name
   * @returns Observable
   */
  public renamePlanView(projectId: number, planId: number, planName: string): Observable<boolean> {
    this.path = `/projects/${projectId}/views/${planId}`;
    const body = JSON.stringify({ name: planName });
    return this.put({ body });
  }

  /**
   * Delete the plan view.
   *
   * @param projectId the project name
   * @param planId the plan id name
   * @returns Observable
   */
  public deletePlanView(projectId: number, planId: number): Observable<boolean> {
    this.path = `/projects/${projectId}/views/${planId}`;
    return this.delete();
  }

  /**
   * Get the plan list view.
   *
   * @param projectId the project name
   * @param planId the plan id name
   * @returns Observable<BuildingLevelFull[]>
   */
  public getPlanListView(projectId: number, planId: number): Observable<BuildingLevelFull[]> {
    this.path = `/projects/${projectId}/views/${planId}/plans`;
    return this.get();
  }

  /**
   * Implement inherited abstract member 'createNewInstance' from BydRhsAbstractService.
   */
  public createNewInstance() {}
}
